import React from "react";

export const ActionTrashIcon = () => (
  <svg
    className="dom-trash-icon"
    width="23"
    height="23"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M6.0013 2V2.66667H2.66797V4H3.33464V12.6667C3.33464 13.0203 3.47511 13.3594 3.72516 13.6095C3.97521 13.8595 4.31435 14 4.66797 14H11.3346C11.6883 14 12.0274 13.8595 12.2774 13.6095C12.5275 13.3594 12.668 13.0203 12.668 12.6667V4H13.3346V2.66667H10.0013V2H6.0013ZM4.66797 4H11.3346V12.6667H4.66797V4ZM6.0013 5.33333V11.3333H7.33464V5.33333H6.0013ZM8.66797 5.33333V11.3333H10.0013V5.33333H8.66797Z"
      fill="#45556c"
    />
  </svg>
);
